<div class="reschedule-dialog">
  <!-- Current Date Display -->
  <div class="current-date-section">
    <label class="block text-sm font-medium text-gray-600 mb-1">
      Current Next Order Date
    </label>
    <div class="text-lg font-semibold text-gray-900">
      {{ formatCurrentDate() }}
    </div>
  </div>

  <!-- Resume Notice for Paused Orders -->
  @if (resumeAfter) {
    <p-message
      severity="info"
      styleClass="w-full"
      text="This order is paused. Rescheduling will also reactivate the order."
    />
  }

  <!-- Date Picker -->
  <div class="date-picker-section">
    <label class="block text-sm font-medium text-gray-600 mb-2">
      Select New Date
    </label>
    <p-datepicker
      [(ngModel)]="selectedDate"
      [minDate]="minDate"
      [showIcon]="true"
      [iconDisplay]="'input'"
      [showButtonBar]="true"
      [readonlyInput]="true"
      dateFormat="D, M dd, yy"
      placeholder="Select a date"
      styleClass="w-full"
      [disabled]="isLoading"
      appendTo="body"
    />
  </div>

  <!-- Action Buttons -->
  <div class="dialog-footer">
    <p-button
      label="Cancel"
      (onClick)="cancel()"
      severity="secondary"
      [outlined]="true"
      [disabled]="isLoading"
      size="small"
      styleClass="min-w-6rem"
    />
    <p-button
      [label]="resumeAfter ? 'Reschedule & Reactivate' : 'Confirm'"
      (onClick)="confirm()"
      severity="primary"
      [disabled]="!canConfirm() || isLoading"
      [loading]="isLoading"
      icon="pi pi-calendar-plus"
      size="small"
      styleClass="min-w-6rem"
    />
  </div>
</div>
